import React, { useState, useEffect } from "react"
import { FormControl } from "@mui/material"
import Select from "react-select"
import api from "../../../base/services/ResApi"

const AppIDDropdown = (props) => {
  const customStyles = {
    container: (provided) => ({ ...provided, width: "100%", minWidth: 0 }),
    control: (provided) => ({
      ...provided,
      minHeight: 58,
      padding: "6px",
      alignItems: "flex-start",
    }),
    valueContainer: (provided) => ({ ...provided, minWidth: 0 }),
    singleValue: (provided) => ({
      ...provided,
      maxWidth: "100%",
      whiteSpace: "normal",
      overflow: "visible",
      textOverflow: "clip",
    }),
    indicatorsContainer: (provided) => ({ ...provided, flexShrink: 0 }),
    option: (provided) => ({ ...provided, whiteSpace: "normal", overflowWrap: "anywhere", padding: "12px" }),
    menu: (provided) => ({ ...provided, zIndex: 202 }),
    menuPortal: (provided) => ({ ...provided, zIndex: 1500 }),
  }
  const [data, setData] = useState([])

  let apprvConfig = {
    headers: {
      Action: "V_ALL_APPR_APP",
      "Is-Pagination": "false",
      "Sort-Column": "version_code",
      "Sort-Order": "desc",
      Filter: "F_ORG_CODE",
      Value: props.orgCode,
    },
  }
  useEffect(() => {
    const fetchData = () => {
      api
        .get("/applications", apprvConfig)
        .then((res) => {
          setData(res.data?.dataList || [])
          props.setRefresh?.(false)
        })
        .catch((error) => {
          console.log(error)
        })
    }
    fetchData()

  }, [props.orgCode, props.isRefresh])

  return (
    <div style={{ width: "100%", minWidth: 0 }}>
      <p
        style={{
          fontSize: "12px",
          margin: "0 0 6px",
          lineHeight: "18px",
          fontWeight: 500,
        }}
      >
        Application
      </p>
      <FormControl
        sx={{
          minWidth: 0,
          width: "100%",
        }}
        size="medium"
      >
        <Select
          name={props.name}
          autoFocus={props.autoFocus}
          menuPortalTarget={props.menuPortalTarget}
          menuPosition={props.menuPortalTarget ? "fixed" : "absolute"}
          aria-label="App ID"
          aria-invalid={props.error || undefined}
          value={data.find((app) => app.applicationId != null && String(app.applicationId) === String(props.value ?? "")) || null}
          onChange={props.onChange}
          options={data}
          getOptionLabel={(e) => `${e.appName} (${e.appId})`}
          formatOptionLabel={(app) => (
            <div style={{ minWidth: 0, whiteSpace: "normal", overflowWrap: "anywhere", lineHeight: 1.45 }}>
              <div style={{ fontWeight: 500,fontSize: "13px" }}>{app.appName || app.appId}</div>
              {/* <div style={{ fontSize: "12px", marginTop: 3 }}>{app.appId}</div> */}
            </div>
          )}
          getOptionValue={(e) => String(e.applicationId)}
          placeholder="Select Application"
          isClearable
          isDisabled={props.isDisabled}
          styles={customStyles}
        />
      </FormControl>
    </div>
  )
}

export default AppIDDropdown
